import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DECLARACAO_RENDIMENTO } from '../../../../app.constants';
import { DeclRendWebModel } from '../../../shared/models/declRendWeb.model';
import { ResponsavelInforamcaoModel } from '../../../shared/models/responsavelInforamcao.model';



@Injectable()
export class DeclaracaoRendimentoService {


  constructor(private httpClient: HttpClient) { }



  getObterdecl(cdCentrus, aaDecl): Promise<DeclRendWebModel> {
    return this.httpClient
      .get<DeclRendWebModel>(`${DECLARACAO_RENDIMENTO}/obterdecl/${cdCentrus}/${aaDecl}`)
      .toPromise();
  }


  getAnoCorrente(cdCentrus): Promise<number> {
    return this.httpClient
      .get<number>(`${DECLARACAO_RENDIMENTO}/anoCorrente/${cdCentrus}`)
      .toPromise();
  }

  getObterVersao(aaVersao): Promise<number> {
    return this.httpClient
      .get<number>(`${DECLARACAO_RENDIMENTO}/obterVersao/${aaVersao}`)
      .toPromise();
  }

  getObterParametrosIrf(anoExercicio): Promise<ResponsavelInforamcaoModel> {
    return this.httpClient
      .get<ResponsavelInforamcaoModel>(`${DECLARACAO_RENDIMENTO}/obterParametrosIrf/${anoExercicio}`)
      .toPromise();
  }

  getObterDeclCompl(cdCentrus, nrVersao): Promise<string[]> {
    return this.httpClient
      .get<string[]>(`${DECLARACAO_RENDIMENTO}/obterDeclCompl/${cdCentrus}/${nrVersao}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento/service/declaracao-rendimento.service.ts